export default __webpack_public_path__ + "fonts/investor-outreach-logo.svg";